
import Vue from 'vue'
import Router from 'vue-router'
import Index from '@/components/index'
import placeIndex from '@/components/placeOrder/placeIndex' //下单
import Personalindex from '@/components/PersonalCenter/Personalindex' //个人中心
import userCountshow from '@/components/PersonalCenter/userCountshow' //个人中心首页展示
import BulkOrderbysea from '@/components/PersonalCenter/BulkOrder/BulkOrderbysea' //海运散货
import OrderDetails from '@/components/PersonalCenter/BulkOrder/OrderDetails' //海运散货查看详情
import tabelTest from '@/components/PersonalCenter/billType/tabelTest' //我的账单
import PayDetail from '@/components/PersonalCenter/billType/PayDetail' //我的账单
import PayOrder from '@/components/PersonalCenter/billType/PayOrder' //支付
import PayRecord from '@/components/PersonalCenter/billType/PayRecord' //我的账单
import UserManage from '@/components/PersonalCenter/accountManage/UserManage' //用户管理
import SubaccountManage from '@/components/PersonalCenter/accountManage/SubaccountManage' //子账号管理
import ManagementRole from '@/components/PersonalCenter/accountManage/ManagementRole'//角色管理
import PermissionAssignment from '@/components/PersonalCenter/accountManage/PermissionAssignment'//查看权限，分配权限
// 个人中心

import ReceivePage from '@/components/PersonalCenter/personalInfo/ReceivePage' //收件人
import PickPage from '@/components/PersonalCenter/personalInfo/PickPage' //提货人
import SendPage from '@/components/PersonalCenter/personalInfo/SendPage' //发货人
import TrackSetting from '@/components/PersonalCenter/personalInfo/TrackSetting' //轨迹设置
// import ReceivePage from '@/components/PersonalCenter/personalInfo/ReceivePage' //用户管理

import buikAllbox from '@/components/PersonalCenter/buikAllbox/buikAllbox' //海运整柜
import AirOrder from '@/components/PersonalCenter/AirOrder/AirOrder' //空运
import AirOrderDetail from '@/components/PersonalCenter/AirOrder/AirOrderDetail' //空运

import Smallbag from '@/components/PersonalCenter/Smallbag/Smallbag' //跨境小包
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'

import FbaOrderDetails from '@/components/PersonalCenter/FBAheader/FbaOrderDetails' //FBA委托完成
import Classify from '@/components/PersonalCenter/personalInfo/Classify' //商品分类
import FbaGoodsBase from '@/components/PersonalCenter/FBAheader/FbaGoodsBase' //FBA商品基本信息
import FbnAppointment from '@/components/PersonalCenter/FBAheader/FbnAppointment' //FBN约仓管理

// 报价管理
import partition from '@/components/QuotationManagement/partition' //分区管理
import ChargingTemplate from '@/components/QuotationManagement/ChargingTemplate' //计费模板
import Logistics from '@/components/QuotationManagement/Logistics' //物流产品管理
import ProductQuotation from '@/components/QuotationManagement/ProductQuotation' //产品报价设置
import Addedservice from '@/components/QuotationManagement/Addedservice' //增值服务报价设置
import DeclareCustoms from '@/components/QuotationManagement/DeclareCustoms' //报关手续费设置
import Delivery from '@/components/QuotationManagement/Delivery' //派送费设置

import productQuotationSetting from '@/components/QuotationManagement/productQuotationSetting' //产品报价设置(新：多合一版本)

// 基础数据
import warehouseManagement from '@/components/baseData/warehouseManagement' // 仓库管理
import overseaWarehouseManagement from '@/components/baseData/overseaWarehouseManagement'

// 财务管理
import myCost from '@/components/financialManagement/myCost' // 我的费用
import costAdjustmentManagement from '@/components/financialManagement/costAdjustmentManagement' // 费用调整管理
import myBill from '@/components/financialManagement/myBill' // 我的账单
import myBillDetails from '@/components/financialManagement/myBillDetails' // 我的账单详情

// 订单管理
import FBAHeader from '@/components/orderManagement/FBAHeader' // FBA头程
import FBAHeaderDetails from '@/components/orderManagement/FBAHeaderDetails' // FBA头程详情
import trackManagement from '@/components/orderManagement/trackManagement' // 按箱维护轨迹
//干线订单
import mainOrdersList from '@/components/mainOrders/main-orders-list' // 列表
import mainOrdersDetail from '@/components/mainOrders/main-orders-detail' // 详情


NProgress.configure({ showSpinner: false }) // 配置NProgress

const originalPush = Router.prototype.push
Router.prototype.push = function push (location) {
  return originalPush.call(this, location).catch(err => err)
}

Vue.use(Router)
const router = new Router({
  routes: [
    {
      path: '/',
      redirect: 'index/placeOrder/placeIndex'
    },
    {
      path: '/index',
      name: 'index',
      component: Index,
      children: [
        {
          path: 'placeOrder/placeIndex', //登录页面首页
          component: placeIndex,
        },
        {
          path: 'PersonalCenter/Personalindex', //个人中心首页默认空页面
          name: 'Personalindex',
          component: Personalindex,
          children: [
            {
              path: 'PersonalCenter/userCountshow', //个人中心首页展示
              component: userCountshow,
              name: 'userCountshow',
              meta: { title: true }
            },
            {
              path: 'PersonalCenter/BulkOrder/BulkOrderbysea/OrderDetails', //海运散货查看详情
              name: 'OrderDetails',
              component: OrderDetails,
            },
            {
              path: 'PersonalCenter/billType/PayDetail', //支付详情
              name: 'PayDetail',
              component: PayDetail,
            },
            {
              path: 'PersonalCenter/billType/PayRecord', //我的账单
              name: 'PayRecord',
              component: PayRecord,
              meta: { title: true }
            },
            {
              path: 'PersonalCenter/accountManage/UserManage', ////用户管理
              name: 'UserManage',
              component: UserManage,
              meta: { title: true }
            },
            {
              path: 'PersonalCenter/accountManage/SubaccountManage', ////子账号管理
              name: 'SubaccountManage',
              component: SubaccountManage,
              meta: { title: true }
            },
            {
              path: 'PersonalCenter/accountManage/ManagementRole', //角色管理
              name: 'ManagementRole',
              component: ManagementRole,
              meta: { title: true }
            },
            {
              path: 'PersonalCenter/accountManage/PermissionAssignment', //角色管理,查看权限，分配权限
              name: 'PermissionAssignment',
              component: PermissionAssignment,
              meta: { title: true }
            },
            {
              path: 'PersonalCenter/personalInfo/Classify', ////商品分类
              name: 'Classify',
              component: Classify,
              meta: { title: true }
            },
            {
              path: 'PersonalCenter/personalInfo/FbaGoodsBase', //商品基本信息
              name: 'FbaGoodsBase',
              component: FbaGoodsBase,
              meta: { title: true }
            },
            {
              path: 'PersonalCenter/personalInfo/FbnAppointment', //fbn约仓管理
              name: 'FbnAppointment',
              component: FbnAppointment,
              meta: { title: true }
            },
            {
              path: 'PersonalCenter/personalInfo/ReceivePage', ////收货人
              name: 'ReceivePage',
              component: ReceivePage,
              meta: { title: true }
            },

            {
              path: 'PersonalCenter/personalInfo/PickPage', ////提货人
              name: 'PickPage',
              component: PickPage,
              meta: { title: true }
            },

            {
              path: 'PersonalCenter/personalInfo/SendPage', ////发货人
              name: 'SendPage',
              component: SendPage,
              meta: { title: true }
            }
            ,

            {
              path: 'PersonalCenter/personalInfo/TrackSetting', ////轨迹
              name: 'TrackSetting',
              component: () => import('@/components/PersonalCenter/personalInfo/TrackSetting'),
              meta: { title: true }
            }
            ,

            {
              path: 'PersonalCenter/personalInfo/Classify', ////发货人
              name: 'Classify',
              component: Classify,
            }
            ,
            {
              path: 'PersonalCenter/buikAllbox/buikAllbox', //海运整柜
              component: buikAllbox,
              name: 'buikAllbox',
              meta: { title: true }

            },
            {

              path: 'PersonalCenter/AirOrder/AirOrder', //空运
              component: AirOrder,
              name: 'AirOrder',
              meta: { title: true }

            },
            {

              path: 'PersonalCenter/AirOrder/AirOrderDetail', //空运详情
              component: AirOrderDetail,
              name: 'AirOrderDetail',
              meta: { title: true }

            },
            {
              path: 'PersonalCenter/FBAheader/FbaOrderDetails', //FBA订单详情
              component: FbaOrderDetails,
              name: 'FbaOrderDetails',
              meta: { title: true }
            },
            {
              path: 'mainOrders/mainOrdersList', //干线订单列表
              component: mainOrdersList,
              name: 'mainOrdersList',
              meta: { title: true }
            },
            {
              path: 'mainOrders/mainOrdersDetail', //干线订单详情
              component: mainOrdersDetail,
              name: 'mainOrdersDetail',
              meta: { title: false }
            },
            {
              path: 'PersonalCenter/Smallbag/Smallbag', //跨境小包
              component: Smallbag,
              name: 'Smallbag',
              meta: { title: true }
            },
            // ------------------报价管理------------
            {
              path: 'QuotationManagement/partition', //分区管理
              component: partition,
              name: 'partition',
              meta: { title: true }
            },
            {
              path: 'QuotationManagement/ChargingTemplate', //分区管理
              component: ChargingTemplate,
              name: 'ChargingTemplate',
              meta: { title: true }
            },
            {
              path: 'QuotationManagement/Logistics', //分区管理
              component: Logistics,
              name: 'Logistics',
              meta: { title: true }
            },
            {
              path: 'QuotationManagement/ProductQuotation', //产品报价设置
              component: ProductQuotation,
              name: 'ProductQuotation',
              meta: { title: true }
            },
            {
              path: 'QuotationManagement/productQuotationSetting', //产品报价设置(新)
              component: productQuotationSetting,
              name: 'productQuotationSetting',
              meta: { title: true }
            },
            {
              path: 'QuotationManagement/Addedservice', //分区管理
              component: Addedservice,
              name: 'Addedservice',
              meta: { title: true }
            },
            {
              path: 'QuotationManagement/DeclareCustoms', //分区管理
              component: DeclareCustoms,
              name: 'DeclareCustoms',
              meta: { title: true }
            },
            {
              path: 'QuotationManagement/Delivery', //分区管理
              component: Delivery,
              name: 'Delivery',
              meta: { title: true }
            },
            {
              path: 'QuotationManagement/quoteTemplate', //报价模板
              component: () => import('@/components/QuotationManagement/quoteTemplate'),
              name: 'quoteTemplate',
              meta: { title: true }
            },
            {
              path: 'QuotationManagement/smartQuote', //smart报价
              component: () => import('@/components/QuotationManagement/smartQuote'),
              name: 'smartQuote',
              meta: { title: true }
            },
            {
              path: 'baseData/warehouseManagement', //仓库管理
              component: warehouseManagement,
              name: 'warehouseManagement',
              meta: { title: true }
            },
            {
              path: 'baseData/overseaWarehouseManagement',
              component: overseaWarehouseManagement,
              name: 'overseaWarehouseManagement',
              meta: { title: true }
            },
            {
              path: 'financialManagement/myCost', //我的费用
              component: myCost,
              name: 'myCost',
              meta: { title: true }
            },
            {
              path: 'financialManagement/costAdjustmentManagement', //费用调整管理
              component: costAdjustmentManagement,
              name: 'costAdjustmentManagement',
              meta: { title: true }
            },
            {
              path: 'financialManagement/myBill', //我的账单
              component: myBill,
              name: 'myBill',
              meta: { title: true }
            },
            {
              path: 'financialManagement/myBillDetails', //我的账单详情
              component: myBillDetails,
              name: 'myBillDetails',
              meta: { title: true }
            },
            {
              path: 'orderManagement/FBAHeader', //FBA头程订单
              component: FBAHeader,
              name: 'FBAHeader',
              meta: { title: true }
            },
            {
              path: 'orderManagement/FBAHeaderDetails', //FBA头程订单详情
              component: FBAHeaderDetails,
              name: 'FBAHeaderDetails',
              meta: { title: true }
            },
            {
              path: 'orderManagement/platformBeforeOrderList', //平台预报订单
              component: () => import("@/components/orderManagement/platformBeforeOrderList"),
              name: 'platformBeforeOrderList',
              meta: { title: true }
            },
            {
              path: 'orderManagement/platformBeforeOrderDetails', //平台预报订单详情
              component: () => import("@/components/orderManagement/platformBeforeOrderDetails"),
              name: 'platformBeforeOrderDetails',
              meta: { title: true }
            },
            {
              path: 'orderManagement/trackManagement', //按箱维护轨迹
              component: trackManagement,
              name: 'trackManagement',
              meta: { title: true }
            },
            {
              path: 'QuotationManagement/productAdditionalFee', //产品附加费
              component: () => import("@/components/QuotationManagement/productAdditionalFee"),
              name: 'productAdditionalFee',
              meta: { title: true }
            },
            {
              path: 'PersonalCenter/platformSharedWarehouse',
              component: () => import("@/components/PersonalCenter/platformSharedWarehouse"),
              name: 'platformSharedWarehouse',
              meta: { title: false }
            },
            {
              path: 'fullContainerInquiry/Inquiries',
              name: 'Inquiries',
              component: () => import("@/components/fullContainerInquiry/Inquiries")
            },
            {
              path: 'fullContainerInquiry/MyQuotation',
              name: 'MyQuotation',
              component: () => import("@/components/fullContainerInquiry/myQuotation")
            },
            {
              path: 'fullContainerInquiry/MyOrders',
              name: 'MyOrders',
              component: () => import("@/components/fullContainerInquiry/myOrders")
            },
            {
              path: 'fullContainerInquiry/orderDetail',
              name: 'orderDetail',
              component: () => import("@/components/fullContainerInquiry/orderDetail")
            },
            {
              path: 'inquiryNew/Inquiries',
              name: 'inquiryNewInquiries',
              component: () => import("@/components/inquiryNew/Inquiries")
            },
            {
              path: 'inquiryNew/myInquiries',
              name: 'inquiryNewMyInquiries',
              component: () => import("@/components/inquiryNew/myInquiries")
            },
            {
              path: 'inquiryNew/MyQuotation',
              name: 'inquiryNewMyQuotation',
              component: () => import("@/components/inquiryNew/myQuotation")
            },
            {
              path: 'inquiryNew/MyOrders',
              name: 'inquiryNewMyOrders',
              component: () => import("@/components/inquiryNew/myOrders")
            },
            {
              // ?
              path: 'inquiryNew/orderDetail',
              name: 'inquiryNewOrderDetail',
              component: () => import("@/components/inquiryNew/orderDetail")
            },
            {
              path: 'expenseTemplateManagement/destinationCountryFeeTemplate',
              name: 'destinationCountryFeeTemplate',
              component: () => import("@/components/expenseTemplateManagement/destinationCountryFeeTemplate")
            },
            // 尾程报价
            {
              path: 'TailQuotationManagement/customsClearanceQuotationManagement',
              name: 'customsClearanceQuotationManagement',
              component: () => import("@/components/TailQuotationManagement/customsClearanceQuotationManagement")
            },
            {
              path: 'TailQuotationManagement/raiseDisassembleQuotationManagement',
              name: 'raiseDisassembleQuotationManagement',
              component: () => import("@/components/TailQuotationManagement/raiseDisassembleQuotationManagement")
            },
            {
              path: 'TailPriceManagement/queryTailPrice',
              name: 'queryTailPrice',
              component: () => import("@/components/TailPriceManagement/queryTailPrice"),
              meta: {keepAlive: true}
            },
            {
              path: 'TailPriceManagement/placeOrder',
              name: 'placeOrder',
              component: () => import("@/components/TailPriceManagement/placeOrder")
            },
            {
              path: 'TailPriceManagement/clearanceOrder',
              name: 'clearanceOrder',
              component: () => import("@/components/TailPriceManagement/clearanceOrder")
            },
            {
              path: 'TailPriceManagement/orderSuccess',
              name: 'orderSuccess',
              component: () => import("@/components/TailPriceManagement/orderSuccess")
            },
            {
              path: 'TailPriceManagement/myOrder',
              name: 'tailPriceOrder',
              component: () => import("@/components/TailPriceManagement/myOrder")
            },
            {
              path: 'TailPriceManagement/myOrderDetail',
              name: 'myOrderDetail',
              component: () => import("@/components/TailPriceManagement/myOrderDetail")
            },
            // 尾程供应商管理尾程订单
            {
              path: 'TailPriceManagement/tailOrder',
              name: 'tailOrder',
              component: () => import("@/components/orderManagement/tailOrder")
            }
          ]
        }
      ]
    }
  ],


})

//挂载路由导航守卫
router.beforeEach((to, from, next) => {
  let whiteList = ['/index/placeOrder/placeIndex',
    '/index/PersonalCenter/Personalindex/PersonalCenter/userCountshow'
  ]
  NProgress.start()
  //  next() 放行    next('/login') 强制跳转
  // console.log('to-----')
  // console.log(to)
  // console.log('from-----')
  // console.log(from)

  // 如果为true为需要鉴权的网页
  // if(to.meta.title){
  //          // console.log('meta1');
  //         let authorities = window.sessionStorage.getItem('authList')
  //         authorities = JSON.parse(authorities)
  //         authorities = [...authorities,...whiteList]
  //         // 如果此路由包含在内就通过
  //             if(authorities.includes(to.path)){
  //               next()
  //             }else{
  //               alert('无权访问')
  //             }
  //   // 不需要鉴权直接过
  // }else{
  next()
  // }



})
router.afterEach(() => {
  NProgress.done()
})
export default router



// WEBPACK FOOTER //
// ./src/router/index.js